/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Event_Aria_LabelInputs */

const en_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert new event`)
};

const fr_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer un nouvel evenement`)
};

const de_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Ereignis einfügen`)
};

const it_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci nuovo evento`)
};

const ru_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить новое событие`)
};

const es_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar nuevo evento`)
};

const zh_cn2_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入新事件`)
};

const ja_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントを挿入`)
};

const hi_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट डालें`)
};

const pt_pt2_add_event_aria_label = /** @type {(inputs: Add_Event_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir novo evento`)
};

/**
* | output |
* | --- |
* | "Insert new event" |
*
* @param {Add_Event_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const add_event_aria_label = /** @type {((inputs?: Add_Event_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Event_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_add_event_aria_label(inputs)
	if (locale === "de") return de_add_event_aria_label(inputs)
	if (locale === "it") return it_add_event_aria_label(inputs)
	if (locale === "ru") return ru_add_event_aria_label(inputs)
	if (locale === "es") return es_add_event_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_add_event_aria_label(inputs)
	if (locale === "ja") return ja_add_event_aria_label(inputs)
	if (locale === "hi") return hi_add_event_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_add_event_aria_label(inputs)
	return en_add_event_aria_label(inputs)
});